import styled from 'styled-components';
import { Form } from 'antd';

export const StyledForm = styled(Form)`
  .ant-form-item-required::before {
    top: 2px;
  }
  .ant-legacy-form-item-required::after {
    margin-left: 2px;
  }
`
